import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rating-widget" }
const _hoisted_2 = ["name", "value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      name: _ctx.name,
      type: "hidden",
      value: $data.local
    }, null, 8 /* PROPS */, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.range, (i) => {
      return (_openBlock(), _createBlock(_component_icon, {
        key: i,
        class: "review-star",
        name: i <= $data.local ? 'STAR' : 'STAR_EMPTY',
        onClick: () => ($data.local = i)
      }, null, 8 /* PROPS */, ["name", "onClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}